<template>
  <span>
    <small v-if="isTwoTone">Only outline</small>
    <svg v-else class="icon-color-1" :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.7311 12C14.2164 12 16.2311 9.98528 16.2311 7.5C16.2311 5.01472 14.2164 3 11.7311 3C9.2458 3 7.23108 5.01472 7.23108 7.5C7.23108 9.98528 9.2458 12 11.7311 12Z" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M18.2201 15.3661L15.034 18.5521C14.908 18.6781 14.7911 18.9121 14.7641 19.0831L14.5931 20.298C14.5301 20.739 14.8361 21.0451 15.2771 20.9821L16.492 20.8111C16.663 20.7841 16.9061 20.6671 17.0231 20.5411L20.209 17.3551C20.758 16.8061 21.019 16.1671 20.209 15.3571C19.408 14.5561 18.7691 14.8171 18.2201 15.3661Z" :stroke="color" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M17.7611 15.825C18.0311 16.797 18.7871 17.5529 19.7591 17.8229" :stroke="color" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M4 21C4 17.517 7.46502 14.7 11.731 14.7C12.667 14.7 13.567 14.8349 14.404 15.0869" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default: '#B6BCC4' },
    color2: { type: String, default: '#fff' },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean },
  }
}
</script>